import { useOpenModal } from '@flowus/common/next-modal';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';
import { useCallback } from 'react';
import { selectCount } from 'src/mind-map/component/collapse-count';
import { cache } from 'src/redux/store';
import { useLimitConfig } from 'src/services/app/hook/subscription-data';
import { OpenSettingFrom } from 'src/views/main/setting-modal/type';
import { useOpenUpgradeSpace } from 'src/views/main/setting-modal/use-open-setting-modal';
import { useIsProSpace } from '../space/use-is-pro-space';

/**
 * 返回true表示会弹窗
 */
export const useOpenUpgradeSpaceIfMindNodeLimit = () => {
  const { t } = useAppTranslation();
  const isPro = useIsProSpace();
  const openModal = useOpenModal();
  const openUpgradeSpace = useOpenUpgradeSpace();
  const { mindMapMaxLimit } = useLimitConfig();

  return useCallback(
    (
      blockId: string,
      content = t('hooks.mind_node_limit.reached_limit', { limit: mindMapMaxLimit }),
      maxCount = mindMapMaxLimit
    ) => {
      const count = selectCount(cache, blockId, blockId);
      if (count >= maxCount && !isPro) {
        // 免费版本的要弹窗
        openModal.warning({
          title: '',
          content,
          confirmText: t('common.upgrade_space'),
          cancelText: t('common.think_again'),
          colorType: 'active',
          confirm: () => {
            openUpgradeSpace(OpenSettingFrom.mind_node_limit);
          },
        });
        return true;
      }
    },
    [isPro, mindMapMaxLimit, openModal, openUpgradeSpace, t]
  );
};
